const routes = [
  {
    path: "/",
    name: "Login",
    component: resolve => require(["../pages/Login/Login"], resolve)
  },
  {
    path: "/home",
    component: resolve => require(["../layout/home/home.vue"], resolve),
    redirect: "/home/HomePage",
    children: [
      {
        path: "HomePage",
        name: "HomePage",
        component: resolve => require(["../pages/Home/index"], resolve)
      }
    ]
  },
  {
    path: "/omanag",
    component: resolve =>
      require(["../layout/omanagement/omanagement.vue"], resolve),
    redirect: "/omanag/OrganizationMation",
    children: [
      {
        path: "Olist",
        name: "Olist",
        component: resolve =>
          require(["../pages/OrganizationSetup/Organizationsetup.vue"], resolve)
      },
      {
        path: "OrganizationMation",
        name: "OrganizationMation",
        component: resolve =>
          require([
            "../pages/OrganizationSetup/OrganizationMation.vue"
          ], resolve)
      }
    ]
  },
  {
    path: "/admin",
    component: resolve =>
      require(["../layout/meeting/DashboardLayout.vue"], resolve),
    redirect: "/admin/MyMeeting",
    children: [
      {
        path: "MyMeeting",
        name: "MyMeeting",
        component: resolve => require(["@/pages/MyMeeting/MyMeeting"], resolve)
      },

      {
        path: "Special",
        /* 专题 */
        name: "Special",
        component: resolve => require(["../pages/MyMeeting/special"], resolve)
      },
      {
        path: "Newspecial",
        /* 新建专题 */
        name: "Newspecial",
        component: resolve =>
          require(["../pages/MyMeeting/newspecial.vue"], resolve)
      },
      {
        path: "AnewMeeting",
        name: "AnewMeeting",
        component: resolve =>
          require(["@/pages/AnewMeeting/AnewMeeting"], resolve)
      },
      {
        path: "MeetingDetails",
        name: "MeetingDetails",
        component: resolve =>
          require(["../pages/MeetingDetails/MeetingDetails"], resolve)
      },
      {
        path: "TheRegistrationManagement",
        name: "TheRegistrationManagement",
        component: resolve =>
          require([
            "../pages/TheRegistrationManagement/TheRegistrationManagement"
          ], resolve),
        meta: {
          title: "报名管理",
          keepAlive: true
        }
      },
      {
        path: "TheOrderManagement",
        name: "TheOrderManagement",
        component: resolve =>
          require(["../pages/TheOrderManagement/TheOrderManagement"], resolve),
        meta: {
          title: "订单管理",
          keepAlive: true
        }
      },
      {
        path: "InvoiceManagement",
        name: "InvoiceManagement",
        component: resolve =>
          require(["../pages/InvoiceManagement/InvoiceManagement"], resolve)
      },
      {
        path: "Institutions",
        name: "Institutions",
        component: resolve =>
          require(["../pages/Institutions/Institutions"], resolve)
      },
      {
        path: "Announcements",
        name: "Announcements",
        component: resolve =>
          require(["../pages/Announcements/Announcements"], resolve)
      },
      {
        path: "AnewMessage",
        name: "AnewMessage",
        component: resolve =>
          require(["../pages/Announcements/AnewMessage/AnewMessage"], resolve)
      },

      {
        path: "Orderdetails",
        name: "Orderdetails",
        component: resolve =>
          require(["../pages/OrderDetails/Order_details.vue"], resolve)
      },
      {
        path: "Zuowei",
        name: "Zuowei",
        component: resolve =>
          require(["../pages/MeetingDetails/Zuowei"], resolve)
      },
      {
        path: "Authoritycontrol",
        name: "Authoritycontrol",
        component: resolve =>
          require(["../pages/MeetingDetails/authorityControl.vue"], resolve)
      }
    ]
  },
  {
    path: "/dataStatistics",
    name: "DataStatistics",
    component: resolve =>
      require(["../layout/dataStatistics/dataStatistics"], resolve)
  },
  {
    path: "/Guest",
    name: "Guest",
    component: resolve => require(["../layout/jiabign/jiabing.vue"], resolve),
    redirect: "/Guest/GuestManagement",
    children: [
      {
        path: "GuestManagement",
        name: "GuestManagement",
        component: resolve =>
          require([
            "../pages/UserManagement/GuestManagement/GuestManagement"
          ], resolve)
      },
      {
        path: "NewGuest",
        name: "NewGuest",
        component: resolve =>
          require([
            "../pages/UserManagement/GuestManagement/NewGuest/NewGuest"
          ], resolve)
      },
      {
        path: "UserManagement",
        name: "UserManagement",
        component: resolve =>
          require(["../pages/UserManagement/UserManagement"], resolve)
      },
      {
        path: "Free",
        name: "Free",
        component: resolve =>
          require(["../pages/UserManagement/freepeople"], resolve)
      }
    ]
  },
  {
    path: "/Formation",
    name: "Formation",
    component: resolve =>
      require(["../layout/formation/formation.vue"], resolve),
    redirect: "/Formation/Inforamtion",
    children: [
      {
        path: "Inforamtion",
        name: "Inforamtion",
        component: resolve =>
          require(["../pages/Information/Information.vue"], resolve)
      },
      {
        path: "AddInforamtion",
        name: "AddInforamtion",
        component: resolve =>
          require(["../pages/Information/addFormation.vue"], resolve)
      }
    ]
  },
  {
    path: "/nopeople",
    component: resolve => require(["../pages/no_people.vue"], resolve)
  },
  {
    path: "*",
    component: resolve => require(["../pages/NotFoundPage.vue"], resolve)
  }
];
export default routes;
